import { PathLocationStrategy, PlatformLocation, Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable()
export class CustomLocationStrategy extends PathLocationStrategy {
  private readonly configService = inject(ConfigurationService);
  private readonly platform = inject(PlatformLocation);
  private readonly spaBaseUrl = this.configService.getValueOrBlank(
    configuration.ConfigMeta.OEL_SPA_BASE_URL,
  );

  private buildUrl(path: string): string {
    return `${globalThis.location.origin}${this.spaBaseUrl}${path}`;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override pushState(state: any, title: string, path: string): void {
    const url = this.buildUrl(path);
    this.platform.pushState(state, title, url);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  override replaceState(state: any, title: string, path: string): void {
    const url = this.buildUrl(path);
    this.platform.replaceState(state, title, url);
  }

  override path(includeHash = false): string {
    let pathname = this.platform.pathname + Location.normalizeQueryParams(this.platform.search);
    const hash = this.platform.hash;
    if (this.spaBaseUrl && pathname.startsWith(this.spaBaseUrl)) {
      pathname = pathname.slice(this.spaBaseUrl.length);
    }
    return hash && includeHash ? `${pathname}${hash}` : pathname;
  }
}
